const draggableList = document.getElementById("draggable-list");

const actionButtons = [
  "Subscription",
  "Account Hierarchy",
  "Addressess",
  "Payment methods",
  "Additional Contacts",
];

const buttons = [];

let dragStartIndex;

createList();

function createList() {
  [...actionButtons].forEach((item, index) => {
    const listItem = document.createElement("li");
    listItem.setAttribute("data-index", index);
    listItem.setAttribute("class", "bg-slate-50");
    listItem.innerHTML = `
        <div draggable="true" class="flex items-center my-2 p-2 rounded draggable">
        <svg class="mr-4" width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2" cy="2" r="1.25" fill="#64648C"/>
        <circle cx="2" cy="7" r="1.25" fill="#64648C"/>
        <circle cx="2" cy="12" r="1.25" fill="#64648C"/>
        <circle cx="8" cy="2" r="1.25" fill="#64648C"/>
        <circle cx="8" cy="7" r="1.25" fill="#64648C"/>
        <circle cx="8" cy="12" r="1.25" fill="#64648C"/>
        </svg>
              <p class="text-sm text-slate-600">${item}</p>
        </div>
        `;
    buttons.push(listItem);
    draggableList.appendChild(listItem);
  });
  addEventListeners();
}

function dragStart() {
  dragStartIndex = +this.closest("li").getAttribute("data-index");
}

function dragEnter() {
  this.classList.add("bg-slate-200");
}

function dragLeave() {
  this.classList.remove("bg-slate-200");
}

function dragOver(e) {
  console.log("Event: ", "dragover");
  e.preventDefault();
}

function dragDrop() {
  console.log("Event: ", "drop");
  const dragEndIndex = this.getAttribute("data-index");
  swapItems(dragStartIndex, dragEndIndex);
  this.classList.remove("bg-slate-200");
}

// Swap list items that are drag and drop
function swapItems(fromIndex, toIndex) {
  const itemOne = buttons[fromIndex].querySelector(".draggable");
  const itemTwo = buttons[toIndex].querySelector(".draggable");

  buttons[fromIndex].appendChild(itemTwo);
  buttons[toIndex].appendChild(itemOne);
}

function addEventListeners() {
  const draggables = document.querySelectorAll(".draggable");
  const dragListItems = document.querySelectorAll(".draggable-list li");

  draggables.forEach((draggable) => {
    draggable.addEventListener("dragstart", dragStart);
  });

  dragListItems.forEach((item) => {
    item.addEventListener("dragover", dragOver);
    item.addEventListener("drop", dragDrop);
    item.addEventListener("dragenter", dragEnter);
    item.addEventListener("dragleave", dragLeave);
  });
}
